import { onlineManager } from '@tanstack/react-query';
import { useSyncExternalStore } from 'react';

/** Ob die App sich für online hält — dieselbe Quelle, nach der TanStack Abfragen pausiert. */
export function useOnline(): boolean {
  return useSyncExternalStore(
    (onChange) => onlineManager.subscribe(onChange),
    () => onlineManager.isOnline(),
    () => true,
  );
}
